module.exports = __webpack_public_path__ + "files/60c2fa4c085b81fb77e919b9c42405f8.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/google-fonts/fonts/lora-italic-webfont.svg
 ** module id = 938
 ** module chunks = 0
 **/